<template>
  <div
    class="card"
    :id="`channel-card-${channel.channel}`"
    :class="{ selected: selected }"
    @click="emit('click', channel.channel)"
  >
    <SocialIcon :type="channel.type" />

    <h4>{{ channel.title }}</h4>

    <p>{{ channel.description }}</p>

    <a class="link" :href="`${DOCS_URL}/${channel.slug}`" target="_blank" rel="noopener noreferrer" @click.stop>
      Más información
      <IconExternalLink active />
    </a>
  </div>
</template>

<script setup lang="ts">
import SocialIcon from "@/app/channels/components/cards/SocialIcon.vue";
import { computed } from "vue";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";

const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/flujos/chatbots`;

interface CardChannel {
  type: string;
  title: string;
  description: string;
  hoverColor: string;
  channel: number;
  slug: string;
}

const props = defineProps<{
  channel: CardChannel;
  selected: boolean;
}>();

const emit = defineEmits<{
  click: [channel: number];
}>();

const hoverColor = computed(() => props.channel.hoverColor);
</script>

<style scoped lang="sass">
h4
  color: $blue-6
  font-size: 16px
  margin-bottom: 4px

p
  font-size: 12px
  color: $gray-8
  margin-bottom: 4px
  height: 36px

a 
  display: inline-flex
  align-items: center
  gap: 4px
  font-size: 12px
  :deep(svg)
    width: 14px
    height: auto

.card
  border-radius: 8px
  border: 1px solid $gray-5
  padding: 20px
  width: 180px
  height:  180px
  cursor: pointer

  &:hover
    border-color: $blue-6
    background-color: v-bind(hoverColor)
    box-shadow: 0px 0px 4px 0px rgba(24, 144, 255, 0.50)

  &.selected
    border-color: $blue-6
    background-color: v-bind(hoverColor)
</style>
